import React, { useState } from "react";
import { postCamion as addCamion } from "../helpers/rutaCamiones";

import "../css/addclienteform.css";
import { Modal } from "react-bootstrap";
import "animate.css";

const tiposUnidad = [
  "CAMIONETA",
  "CAMION",
  "TRACTOR",
  "COSECHADORA",
  "PULVERIZADORA",
  "MAQUINARIA",
  "MOTO",
  "AUTO",
  "OTRO",
];

const modosControl = ["KM", "HORAS"];
const tiposCombustible = ["GASOIL", "NAFTA"];

const getModoPorTipoUnidad = (tipoUnidad) => {
  if (
    ["TRACTOR", "COSECHADORA", "PULVERIZADORA", "MAQUINARIA"].includes(
      tipoUnidad
    )
  ) {
    return "HORAS";
  }

  return "KM";
};

const getCombustiblePorTipoUnidad = (tipoUnidad) => {
  if (["MOTO", "AUTO"].includes(tipoUnidad)) {
    return "NAFTA";
  }

  return "GASOIL";
};

const AddCamionForm = ({ setShow }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const initialValues = {
    codcam: "",
    camion: "",
    patente: "",
    tipoUnidad: "CAMIONETA",
    modoControl: "KM",
    combustibleHabitual: "GASOIL",
    ultimoKmTablero: "",
    ultimoHorometro: "",
    observaciones: "",
  };

  const [formValues, setFormValues] = useState(initialValues);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "tipoUnidad") {
      const modoControl = getModoPorTipoUnidad(value);
      const combustibleHabitual = getCombustiblePorTipoUnidad(value);

      setFormValues({
        ...formValues,
        tipoUnidad: value,
        modoControl,
        combustibleHabitual,
      });

      return;
    }

    if (["camion", "patente", "observaciones"].includes(name)) {
      setFormValues({
        ...formValues,
        [name]: value.toUpperCase(),
      });

      return;
    }

    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const limpiarFormulario = () => {
    setFormValues(initialValues);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        ...formValues,
        ultimoKmTablero: Number(formValues.ultimoKmTablero) || 0,
        ultimoHorometro: Number(formValues.ultimoHorometro) || 0,
      };

      const resp = await addCamion(payload);
      console.log("✅ Vehículo / maquinaria creado:", resp);

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        limpiarFormulario();

        // Si querés cerrar el modal al guardar, descomentá:
        // if (setShow) setShow(false);
      }, 1800);
    } catch (error) {
      console.error("❌ Error al crear vehículo / maquinaria:", error);
      alert("Error al crear vehículo / maquinaria");
    }
  };

  return (
    <>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group mt-3 col-sm-5">
              <label>Vehículo / Maquinaria</label>
              <input
                type="text"
                className="form-control"
                name="camion"
                maxLength="50"
                required
                value={formValues.camion}
                onChange={handleChange}
                placeholder="Ej: TOYOTA HILUX / TRACTOR JOHN DEERE"
              />
            </div>

            <div className="form-group mt-3 col-sm-3">
              <label>Patente / Identificación</label>
              <input
                type="text"
                className="form-control"
                name="patente"
                maxLength="15"
                required
                value={formValues.patente}
                onChange={handleChange}
                placeholder="Ej: AB123CD"
              />
            </div>

            <div className="form-group mt-3 col-sm-4">
              <label>Tipo de unidad</label>
              <select
                className="form-control"
                name="tipoUnidad"
                value={formValues.tipoUnidad}
                onChange={handleChange}
                required
              >
                {tiposUnidad.map((tipo) => (
                  <option key={tipo} value={tipo}>
                    {tipo}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group mt-3 col-sm-3">
              <label>Modo de control</label>
              <select
                className="form-control"
                name="modoControl"
                value={formValues.modoControl}
                onChange={handleChange}
                required
              >
                {modosControl.map((modo) => (
                  <option key={modo} value={modo}>
                    {modo === "KM" ? "Por kilómetros" : "Por horas"}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group mt-3 col-sm-3">
              <label>Combustible habitual</label>
              <select
                className="form-control"
                name="combustibleHabitual"
                value={formValues.combustibleHabitual}
                onChange={handleChange}
                required
              >
                {tiposCombustible.map((tipo) => (
                  <option key={tipo} value={tipo}>
                    {tipo}
                  </option>
                ))}
              </select>
            </div>

            {formValues.modoControl === "KM" && (
              <div className="form-group mt-3 col-sm-3">
                <label>Km inicial tablero</label>
                <input
                  type="number"
                  className="form-control"
                  name="ultimoKmTablero"
                  min="0"
                  step="1"
                  value={formValues.ultimoKmTablero}
                  onChange={handleChange}
                  placeholder="Opcional"
                />
              </div>
            )}

            {formValues.modoControl === "HORAS" && (
              <div className="form-group mt-3 col-sm-3">
                <label>Horómetro inicial</label>
                <input
                  type="number"
                  className="form-control"
                  name="ultimoHorometro"
                  min="0"
                  step="0.01"
                  value={formValues.ultimoHorometro}
                  onChange={handleChange}
                  placeholder="Opcional"
                />
              </div>
            )}
          </div>

          <div className="form-row">
            <div className="form-group mt-3 col-sm-12">
              <label>Observaciones</label>
              <textarea
                className="form-control"
                name="observaciones"
                rows="2"
                maxLength="200"
                value={formValues.observaciones}
                onChange={handleChange}
                placeholder="Observaciones internas"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="btn btn-dark mt-4 mb-3"
              id="button"
            >
              Guardar
            </button>
          </div>
        </form>
      </div>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>✅</div>
          <h5 className="mt-2">¡Registro generado correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddCamionForm;